import { eventsFlux, EventTypes, useEditorSelector } from '@candulabs/craft';
import { ButtonIcon, css, EditIcon, LightningIcon, PlacementIcon, Tooltip } from 'canoe';
import React from 'react';
import styled from 'styled-components';

import { useEventing } from 'commons/eventing';
import { CRAFT_ROOT_ID } from 'craft/constants';
import { TOOLBOX_DOCK_ID } from 'craft/containers/Toolbox/constants';
import { useEditor } from 'craft/hooks';
import { useCurrentSnapshot, useToolboxState } from 'craft/state';
import { ToolboxTabs } from 'craft/types';

const Wrapper = styled.div`
  ${({ theme }) => css`
    position: fixed;
    top: 223px;
    right: ${theme.spaces.s};
    z-index: 100;
  `}
`;

const Container = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    width: 44px;
    height: 132px;
    background: ${theme.colors.White};
    border: 1px solid ${theme.colors.GlitterGray};
    border-radius: ${theme.borderRadius.regular};
    padding: ${theme.spaces.xs};
    box-sizing: border-box;
  `}
`;

export const FloatingToolboxDock = () => {
  const { actions } = useEditor();
  const { track } = useEventing();
  const { isToolboxDocked, setDockedState, setTab } = useToolboxState();
  const { snapshot, isSnapshotLoaded } = useCurrentSnapshot();

  const isNodeSelected =
    useEditorSelector(eventsFlux.selectors.getNodesForEvent(EventTypes.selected)).size() > 0;

  const onClick = (tab: ToolboxTabs) => {
    if (!isNodeSelected) {
      actions.setNodeEvent(EventTypes.selected, [CRAFT_ROOT_ID]);
    }
    setDockedState(false);
    track('editor.dockedToolbox.open');
    setTab(tab);
  };

  if (!isToolboxDocked || (snapshot && !isSnapshotLoaded)) {
    return null;
  }

  return (
    <Wrapper id={TOOLBOX_DOCK_ID} data-craft-ignore-events>
      <Container>
        <Tooltip placement="left" content="Component">
          <ButtonIcon
            id={`editor-toolbox-tab-${ToolboxTabs.Component.toLowerCase()}`}
            color="white"
            inverted
            radius="small"
            icon={EditIcon}
            onClick={() => onClick(ToolboxTabs.Component)}
          />
        </Tooltip>
        <Tooltip placement="left" content="Interactions">
          <ButtonIcon
            id={`editor-toolbox-tab-${ToolboxTabs.Interactions.toLowerCase()}`}
            color="white"
            inverted
            radius="small"
            icon={LightningIcon}
            onClick={() => onClick(ToolboxTabs.Interactions)}
          />
        </Tooltip>
        <Tooltip placement="left" content="Placements">
          <ButtonIcon
            id={`editor-toolbox-tab-${ToolboxTabs.Placements.toLowerCase()}`}
            color="white"
            inverted
            radius="small"
            icon={PlacementIcon}
            onClick={() => onClick(ToolboxTabs.Placements)}
          />
        </Tooltip>
      </Container>
    </Wrapper>
  );
};
